import { IValue } from "./ivalue";
import { ControlType } from "../controltype";
import { EventEmitter } from "@angular/core";

export class MonthValue implements IValue {
    value: string;
    clear$ = new EventEmitter();

    constructor(date: string = '') {
        this.value = date;
    }
    setOriginalValue(value: any): void {
        this.value = value.formatted;
    }
    getOriginalValue() {
        return this.value;
    }
    getControlType(): ControlType {
        return ControlType.Date;
    }

    isEmpty(): boolean {
        return !this.value;
    }
    clearValue(): void {
        this.value = undefined;
        this.clear$.emit();
    }
}
